<div class="timeline timeline-line-dotted">
  <span class="timeline-label">
    <span class="highlighting group">{{tlGroup.eventDateUtc | formatShortDate9 }}</span>
  </span>
  @for (tlItem of tlGroup.timelineItems; track tlItem) {
    <aa-timeline-item [tlItem]="tlItem"></aa-timeline-item>
  }
</div>
